import { Component } from "react";
import { Button } from "@mui/material";
import { connect } from "react-redux";
import { compose } from "redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import { withStyles } from "@mui/styles";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCube, faCubes } from "@fortawesome/free-solid-svg-icons";
import {
    searchProductsAndCategories,
    searchProductsOfSelectedCategory,
    clearSearchProductsOfSelectedCategory,
    clearSearch,
    setSelectedProductDesignation,
} from "../../../redux/product/productActions";
import { SEARCH_LIMIT } from "../../../redux/product/productConstants";
import { TYPING_TIMEOUT } from "../../../constants";
import { arraysAreSame } from "../../../lib/array_helper";
import CustomizedTextField from "../../Input/CustomizedTextField";
import { getCurrentFunctionName } from "../../../performanceModeManager";

const styles = () => ({
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
    root: {
        flexGrow: 1,
        justify: "center",
    },
    grid: {
        width: "100%",
        margin: 0,
        textAlign: "center",
    },
    icon: {
        fontSize: 48,
        display: "block",
        width: "48px",
        height: "48px",
        marginLeft: "auto",
        marginRight: "auto",
    },
});

class InterventionProductField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpenned: false,
            expandedMenuItems: [],
            expandedCategoryItem: false,
            options: [],
            selectedCategoryId: null,
            products: [],
            selectedProductCode: this.props.value.value_text,
            searchFieldValue: "",
            typedJustNow: false,
            columns: [
                {
                    Header: "Articles",
                    Cell: ({ row }) => {
                        let currentProduct = this.props.products[row.index];
                        return (
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                                <div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                                    <span>{currentProduct.name}</span>
                                </div>
                            </div>
                        );
                    },
                },
            ],
        };

        this.props.setSelectedProductDesignation(this.props.value.value_text);
    }

    onMenuOpen() {
        this.setState({ modalOpenned: true });
    }

    close() {
        this.setState({ modalOpenned: false, searchFieldValue: "" });
        this.props.clearSearch();
    }

    handleProductClick(productCode) {
        this.setState({ selectedProductCode: productCode });

        this.props.setSelectedProductDesignation(productCode);
        let fieldValue = this.props.value;
        fieldValue.value_text = productCode;

        this.props.fieldValueChange(fieldValue);
        this.close();
    }

    handleCategoryClick(category) {
        if (category.children && category.children.length > 0) {
            if (this.state.expandedMenuItems.includes(category.id)) {
                let expandedMenuItems = this.state.expandedMenuItems.filter((i) => i !== category.id);
                this.setState({ expandedMenuItems: expandedMenuItems });
            } else {
                let expandedMenuItems = this.state.expandedMenuItems;
                expandedMenuItems.push(category.id);
                this.setState({ expandedMenuItems });
            }
        } else {
            this.props.clearSearchProductsOfSelectedCategory();
            if (this.state.expandedCategoryItem === category.id) {
                this.setState({ expandedCategoryItem: false });
            } else {
                this.props.searchProductsOfSelectedCategory(category.id);
                this.setState({ expandedCategoryItem: category.id });
            }
        }
    }

    limitElement = (
        <div className="row">
            <Typography variant="caption" color="inherit">
                {"Recherche limitées à 20 résultats"}
            </Typography>
        </div>
    );

    productElement = (p, i) => {
        return (
            <div className="option-product-category" key={i}>
                <ListItem button onClick={this.handleProductClick.bind(this, p.default_code)}>
                    <FontAwesomeIcon className="fa-lg" icon={faCube} />
                    <ListItemText primary={"[" + p.default_code + "]" + p.name} />
                </ListItem>
            </div>
        );
    };

    categoryElement = (c, i) => {
        let collapse = null;
        let expandIcon = null;

        if (c.children && c.children.length > 0) {
            expandIcon = this.state.expandedMenuItems.includes(c.id) ? <ExpandLess /> : <ExpandMore />;

            collapse = (
                <Collapse in={this.state.expandedMenuItems.includes(c.id)} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {c.children.map(this.categoryElement.bind(this))}
                    </List>
                </Collapse>
            );
        } else {
            if (this.state.expandedCategoryItem === c.id)
                collapse = (
                    <Collapse in={this.state.expandedCategoryItem === c.id} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {this.props.productsOfSelectedCategory
                                .slice(0, SEARCH_LIMIT)
                                .map(this.productElement.bind(this))}
                        </List>
                        {this.props.productsOfSelectedCategory.length > SEARCH_LIMIT ? this.limitElement : null}
                    </Collapse>
                );
            else expandIcon = <Icon>search</Icon>;
        }

        return (
            <div className="option-product-category" key={i}>
                <ListItem button onClick={this.handleCategoryClick.bind(this, c)}>
                    <FontAwesomeIcon className="fa-lg" icon={faCubes} />
                    <ListItemText primary={c.complete_name} />
                    {expandIcon}
                </ListItem>
                {collapse}
            </div>
        );
    };

    searchProduct(code, categoryId, description) {
        this.props.searchProducts(code, categoryId, description);
    }

    onProductCodeChange(e) {
        let value = e.target.value;

        if (this.state.productCodeChangeTimeout) clearTimeout(this.state.productCodeChangeTimeout);

        this.setState({
            selectedProductCode: value,
            typedJustNow: true,
            productCodeChangeTimeout: setTimeout(() => {
                let fieldValue = this.props.value;
                fieldValue.value_text = value;

                this.props.fieldValueChange(fieldValue);
                this.props.setSelectedProductDesignation(value);

                this.setState({
                    typedJustNow: false,
                });
            }, TYPING_TIMEOUT),
        });
    }

    onSearchFieldChange(e) {
        let value = e.target.value;
        const minLengthOfSearchField = 2;

        if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);

        this.setState({
            searchFieldValue: value,
            searchTimeout: setTimeout(() => {
                if (value.length < minLengthOfSearchField) return;

                this.props.searchProductsAndCategories(value);
            }, TYPING_TIMEOUT),
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.inputProperties !== this.props.inputProperties ||
            this.props.searchProducts.length !== nextProps.searchProducts.length ||
            this.state.modalOpenned !== nextState.modalOpenned ||
            this.state.searchFieldValue !== nextState.searchFieldValue ||
            this.state.selectedProductCode !== nextState.selectedProductCode ||
            arraysAreSame(this.state.expandedMenuItems.length, nextState.expandedMenuItems) ||
            this.state.expandedCategoryItem !== nextState.expandedCategoryItem ||
            arraysAreSame(this.props.productsOfSelectedCategory, nextProps.productsOfSelectedCategory)
        );
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        return (
            <div>
                <div className="row">
                    <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                        <CustomizedTextField
                            value={this.state.selectedProductCode}
                            onChange={this.onProductCodeChange.bind(this)}
                            {...this.props.inputProperties}
                            label={this.props.model.name}
                            className={this.props.inputProperties.className + " full_size control-margin-top"}
                        />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                        <Button
                            variant="contained"
                            size="small"
                            onClick={this.onMenuOpen.bind(this)}
                            {...this.props.inputProperties}
                        >
                            <Icon>search</Icon>
                        </Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                        <CustomizedTextField
                            value={this.props.selectedProductDesignation}
                            {...this.props.inputProperties}
                            id={this.props.inputProperties + "-description"}
                            label={this.props.model.name + " - description"}
                            className={
                                this.props.inputProperties.className + " full_size light-disabled control-margin-top"
                            }
                        />
                    </div>
                </div>
                <Dialog
                    aria-labelledby="simple-dialog-title"
                    fullScreen
                    open={this.state.modalOpenned}
                    onClose={this.close.bind(this)}
                >
                    <AppBar className={classes.appBar} elevation={0}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {"Recherche d'article"}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Toolbar />
                    <DialogContent className="without-side-padding">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <CustomizedTextField
                                label={this.props.model.name}
                                onChange={this.onSearchFieldChange.bind(this)}
                                value={this.state.searchFieldValue}
                            />
                        </div>
                        <div className="row without-side-padding">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12 without-side-padding">
                                <List
                                    component="nav"
                                    aria-labelledby="nested-list-subheader"
                                    subheader={
                                        <ListSubheader
                                            component="div"
                                            id="nested-list-subheader"
                                            className="list-subheader"
                                        >
                                            {"Articles"}
                                        </ListSubheader>
                                    }
                                >
                                    {this.props.searchProducts
                                        .slice(0, SEARCH_LIMIT)
                                        .map(this.productElement.bind(this))}
                                </List>
                                {this.props.searchProducts.length > SEARCH_LIMIT ? this.limitElement : null}
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12 without-side-padding">
                                <List
                                    component="nav"
                                    aria-labelledby="nested-list-subheader"
                                    subheader={
                                        <ListSubheader
                                            component="div"
                                            id="nested-list-subheader"
                                            className="list-subheader"
                                        >
                                            {"Catégories"}
                                        </ListSubheader>
                                    }
                                >
                                    {this.props.searchCategories
                                        .slice(0, SEARCH_LIMIT)
                                        .map(this.categoryElement.bind(this))}
                                </List>
                                {this.props.searchCategories.length > SEARCH_LIMIT ? this.limitElement : null}
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        searchProducts: state.products.searchProducts,
        searchCategories: state.products.searchProductCategories,
        productsOfSelectedCategory: state.products.productsOfSelectedCategory,
        productCategories: state.products.productCategories,
        selectedProductDesignation: state.products.selectedProductDesignation,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchProductsAndCategories: (codeOrDescription) => dispatch(searchProductsAndCategories(codeOrDescription)),
        searchProductsOfSelectedCategory: (selectedCategoryId) =>
            dispatch(searchProductsOfSelectedCategory(selectedCategoryId)),
        clearSearchProductsOfSelectedCategory: () => dispatch(clearSearchProductsOfSelectedCategory()),
        clearSearch: () => dispatch(clearSearch()),
        setSelectedProductDesignation: (code) => dispatch(setSelectedProductDesignation(code)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(InterventionProductField);
